import { getSaleInstance } from './apiService';

const CustomerClassificationServices = {
  get: ({ page, size, sort }) => {
    return getSaleInstance().get(
      `customer-classification?sortBy=${sort ?? 'createdAt:DESC'}&page=${page ??
        0}&size=${size ?? 10}`,
    );
  },
  update: ({ id, data }) => {
    return getSaleInstance().put(`customer-classification/${id}`, data);
  },
  create: payload => {
    return getSaleInstance().post('customer-classification', payload);
  },
  delete: ids => {
    return getSaleInstance().delete(
      `customer-classification/bulk?ids=${ids.join(',')}`,
    );
  },
};

export default CustomerClassificationServices;
